import { styled } from 'styled-components';

import { createResponsiveGeneralStyle, createResponsiveSpacingStyle } from '../../../utils';
import { Container } from '../Container';
import type { FlexProps } from './types';

const Wrapper = styled(Container)<FlexProps>`
  ${props => props.display && createResponsiveGeneralStyle('display', props.display)};
  ${props => props.flexWrap && createResponsiveGeneralStyle('flex-wrap', props.flexWrap)};
  ${props => props.flexDirection && createResponsiveGeneralStyle('flex-direction', props.flexDirection)};
  ${props => props.justifyContent && createResponsiveGeneralStyle('justify-content', props.justifyContent)};
  ${props => props.alignItems && createResponsiveGeneralStyle('align-items', props.alignItems)};
  ${props => props.alignSelf && createResponsiveGeneralStyle('align-self', props.alignSelf)};
  ${props => props.alignContent && createResponsiveGeneralStyle('align-content', props.alignContent)};
  ${props => props.columnGap && createResponsiveSpacingStyle('column-gap', props.columnGap)};
  ${props => props.rowGap && createResponsiveSpacingStyle('row-gap', props.rowGap)};
`;

export const Flex = ({
  style,
  className,
  position,
  boxSizing,
  display = 'flex',
  width,
  minWidth,
  maxWidth,
  height,
  minHeight,
  marginTop,
  marginRight,
  marginBottom,
  marginLeft,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  background,
  backgroundColor,
  flexDirection,
  flexWrap,
  justifyContent,
  alignItems,
  alignContent,
  alignSelf,
  flexGrow,
  flexShrink,
  flexBasis,
  initial,
  animate,
  variants,
  exit,
  transition,
  border,
  borderRadius,
  boxShadow,
  columnGap,
  rowGap,
  children,
}: FlexProps) => (
  <Wrapper
    style={style}
    className={className}
    position={position}
    boxSizing={boxSizing}
    display={display}
    width={width}
    minWidth={minWidth}
    maxWidth={maxWidth}
    height={height}
    minHeight={minHeight}
    marginTop={marginTop}
    marginRight={marginRight}
    marginBottom={marginBottom}
    marginLeft={marginLeft}
    paddingTop={paddingTop}
    paddingRight={paddingRight}
    paddingBottom={paddingBottom}
    paddingLeft={paddingLeft}
    background={background}
    backgroundColor={backgroundColor}
    flexWrap={flexWrap}
    flexDirection={flexDirection}
    justifyContent={justifyContent}
    alignSelf={alignSelf}
    alignItems={alignItems}
    alignContent={alignContent}
    flexGrow={flexGrow}
    flexShrink={flexShrink}
    flexBasis={flexBasis}
    initial={initial}
    animate={animate}
    variants={variants}
    exit={exit}
    transition={transition}
    border={border}
    borderRadius={borderRadius}
    columnGap={columnGap}
    rowGap={rowGap}
    boxShadow={boxShadow}
  >
    {children}
  </Wrapper>
);
